module.exports = __webpack_public_path__ + "static/media/vi.aff583e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/vi.png
// module id = 2018
// module chunks = 0